/** Financial confirmation and bot delivery are separate receipts. */
export function giftDeliveryCopy(state?: string) {
  if (state === 'delivered') return { sent: true, text: 'Бот прислал открытку со ссылкой «Забрать подарок» в подписи.' };
  if (state === 'accepted') return { sent: false, text: 'Открытка передана боту для доставки.' };
  if (state === 'pending' || state === 'sending')
    return { sent: false, text: 'Бот готовит доставку открытки. Можно переслать её самостоятельно.' };
  return { sent: false, text: 'Доставка открытки не подтверждена. Можно переслать её самостоятельно.' };
}

/** Инициалы дарителя на открытке («Ольга Ветрова» → «ОВ»), как у шаблона; одно слово — две первые буквы */
export function initialsOf(name: string) {
  const words = name.trim().split(/\s+/).filter(Boolean);
  return (words.length > 1 ? words.map(w => w[0]).join('') : (words[0] ?? '')).slice(0, 2).toUpperCase();
}

/** Пакет по умолчанию в листе «Докупить Circle»: второй по порядку (у шаблона — 650 C из 250 · 650 · 2 800), если пакетов меньше — первый */
export function defaultPackId<T>(ids: T[]): T | null {
  return ids.length ? ids[Math.min(1, ids.length - 1)] : null;
}
